import { z } from 'zod';
import { isoTimestamp } from './primitives.js';
/*
 * GET /meta/customers — one row per PERSON who came in through a Meta lead
 * form: which ad, which form, whether they booked (and where), whether they
 * showed up, whether they became a member.
 *
 * Built on the same identity + outcome logic as /leads (buildLeadsPayload), so
 * this table and the Leads tab can never disagree about who booked. Outcomes
 * are bounded to the person's FIRST Facebook lead: a booking from before the ad
 * is not the ad's doing.
 *
 * Contains names and phone numbers — dashboard auth only, never public.
 */
const ok = z.literal(true);
/**
 * Where the booking was made.
 *  'nono'    — our own calendar on nono.no (the instant form's thank-you button)
 *  'momence' — in Momence: the host booked it after a call, or the person used
 *              Momence's own booking page (the old form linked there). Momence
 *              does not tell the two apart.
 */
export const metaCustomerBookedViaSchema = z.enum(['nono', 'momence']);
export const metaCustomerSchema = z.object({
    key: z.string(),
    name: z.string(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    /** When the first Facebook lead arrived. */
    leadAt: isoTimestamp,
    adId: z.string().nullable(),
    /** Ad name from Meta; null when Meta could not be asked. */
    adName: z.string().nullable(),
    campaignName: z.string().nullable(),
    formId: z.string().nullable(),
    formName: z.string().nullable(),
    booking: z
        .object({
        bookedAt: isoTimestamp,
        /** The prøvetime itself. */
        slotAt: isoTimestamp.nullable(),
        via: metaCustomerBookedViaSchema,
        cancelled: z.boolean(),
        hoursToBook: z.number(),
    })
        .nullable(),
    /**
     * 'yes' = checked in · 'no' = the time has passed without a check-in ·
     * 'upcoming' = the time is still ahead · null = nothing booked.
     */
    showed: z.enum(['yes', 'no', 'upcoming']).nullable(),
    showedAt: isoTimestamp.nullable(),
    member: z.boolean(),
    memberSince: isoTimestamp.nullable(),
});
export const metaCustomersResponse = z.object({
    ok,
    from: z.string(),
    to: z.string(),
    totals: z.object({
        people: z.number(),
        booked: z.number(),
        bookedNono: z.number(),
        bookedMomence: z.number(),
        showed: z.number(),
        members: z.number(),
    }),
    people: z.array(metaCustomerSchema),
});
//# sourceMappingURL=meta-customers.js.map